module.exports = __webpack_public_path__ + "static/media/position.4a63687f.png";